<template>
  <div class="liu pos-manage">
    <mt-header fixed :title="title" class="title1">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container">
      <div class="form" style="margin-top: 25px">
        <!-- 费率(万分之) -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>设置费率</span>
            </div>
            <div class="content">
              <input type="text" class="rate-text" v-model="rateData" maxlength="10" :placeholder="rateDataPlaceHolder" :disabled="rateDataDisiable" @keyup="onNormalRateInput" />
            </div>
          </div>
        </div>
        <!-- 二维码名称 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>邀请码名称</span>
            </div>
            <div class="content">
              <input type="text" class="rate-text" v-model="qrCodeName" maxlength="15" placeholder="请输入邀请码名称" />
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <mt-button type="primary" size="large" @click="onPageSubmitClick">
          保存设置
        </mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { controlRateInput, formatRateForSubmit } from '@/utils/format';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { GetCurrentAgentFee, ModifiedCustomerInviteCode } from '@/api/customer';
import { validateEmpty, validateRate, validateMinMax } from '@/utils/validate';

export default {
  name: 'PosManageSelfRegFeeEdit',
  data() {
    return {
      title: '邀请码设置',
      rateData: '', // 费率
      rateDataPlaceHolder: '',
      rateDataDisiable: false,
      qrCodeName: '', // 名称
      getRateCodeErrMsg: '', // 如果费率范围接口获取失败
      isValidateData: true,
      tmp: {
        minFee: 0,
        maxFee: 0,
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.getRateCodeErrMsg = '';
      CusLoadingOpen();
      this.getCurrentAgentFee();
    });
  },

  methods: {
    // 返回单击事件
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 设置费率-费率输入事件
    onNormalRateInput() {
      this.rateData = controlRateInput(this.rateData);
    },
    // 保存设置按钮
    onPageSubmitClick() {
      if (this.getRateCodeErrMsg) {
        CusToast(this.getRateCodeErrMsg);
        return;
      }
      if (this.isValidateData) {
        this.validatePageData(() => {
          this.modifiedCustomerInviteCode();
        });
      } else {
        this.modifiedCustomerInviteCode();
      }
    },
    // 通过接口获取代理商费率
    getCurrentAgentFee(callback = null) {
      GetCurrentAgentFee()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusLoadingClose();
              if (res.data.hideFee === 1) {
                this.isValidateData = false;
                this.rateDataDisiable = true;
                this.rateData = res.data.showFee;
              } else {
                this.isValidateData = true;
                this.rateDataDisiable = false;
                this.rateDataPlaceHolder = `${res.data.fee}~${res.data.maxFee}`;
                this.tmp.minFee = res.data.fee;
                this.tmp.maxFee = res.data.maxFee;
              }
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
              this.getRateCodeErrMsg = msg;
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 新增邀请码
    modifiedCustomerInviteCode() {
      CusLoadingOpen();
      const data = {
        fee: formatRateForSubmit(this.rateData),
        remarkName: this.qrCodeName.trim(),
      };
      ModifiedCustomerInviteCode(data)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusLoadingClose();
              CusAlert('保存成功', () => {
                this.$router.go(-1);
              });
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 验证数据合法性
    validatePageData(callback = null) {
      const normalRateErr = validateRate(this.rateData);
      const nomalRateMinMaxErr = validateMinMax(this.rateData, this.tmp.minFee, this.tmp.maxFee);
      const remarkNameTypeErr = validateEmpty(this.qrCodeName);

      if (!normalRateErr && !nomalRateMinMaxErr && !remarkNameTypeErr) {
        callback && callback();
      } else {
        if (normalRateErr === 1) {
          CusToast('费率不能为空');
          return;
        }
        if (normalRateErr === 2) {
          CusToast('请输入合法的费率值');
          return;
        }
        if (normalRateErr === 3) {
          CusToast('费率只能保留两位小数');
          return;
        }
        if (nomalRateMinMaxErr === 1) {
          CusToast(`费率不能高于${this.tmp.maxFee}（万分之）`);
          return;
        }
        if (nomalRateMinMaxErr === 2) {
          CusToast(`费率不能低于${this.tmp.minFee}（万分之）`);
          return;
        }
        if (remarkNameTypeErr) {
          CusToast('邀请码名称不能为空');
          return;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-text {
  text-align: right;
  padding-right: 0.6rem !important;
}
.rate-text:disabled {
  background-color: #fff;
}
</style>
